import { Alert, Select, TextInput } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useState } from "react";
import { getOccupationOptions, type Occupation } from "../../../models/enums/occupation";
import { type Group, getGroupOptions } from "../../../models/group";
import { getYearContextOptions, type YearContext } from "../../../models/yearContext";

export type CommonConfigFormType = {
  group_id?: string;
  year_context_id?: string;
  occupation?: Occupation;
  title?: string;
};

type CommonConfigFormProps<T extends CommonConfigFormType> = {
  form: UseFormReturnType<T>;
  errors?: CommonConfigFormErrorType;
  yearContexts: YearContext[];
  groups: Group[];
};

export type CommonConfigFormErrorType = {
  group_id?: string[];
  year_context_id?: string[];
  occupation?: string[];
  report_type?: string[];
  title?: string[];
};

export function CommonConfigForm<T extends CommonConfigFormType>({ form, errors, yearContexts, groups }: CommonConfigFormProps<T>) {
  const [groupSelected, setGroupSelected] = useState(!!form.values.group_id);
  form.watch("group_id", ({ value }) => setGroupSelected(!!value));

  return (
    <>
      {errors?.report_type && (
        <Alert variant="light" icon={<IconAlertTriangle />} title="Vorlage muss einzigartig sein" color="zli-orange">
          Die Konstellation aus Jahrgang, Beruf und Gruppe muss einzigartig sein.
        </Alert>
      )}
      <Select
        data={getYearContextOptions(yearContexts)}
        key={form.key("year_context_id")}
        {...form.getInputProps("year_context_id")}
        clearable
        label="Jahrgang"
        disabled={groupSelected}
      />
      <Select
        label="Beruf"
        clearable
        data={getOccupationOptions()}
        key={form.key("occupation")}
        {...form.getInputProps("occupation")}
        disabled={groupSelected}
      />
      <Select
        label="Gruppe"
        clearable
        nothingFoundMessage="Keine Gruppen..."
        data={getGroupOptions(groups ?? [])}
        key={form.key("group_id")}
        {...form.getInputProps("group_id")}
      />
      <TextInput withAsterisk label="Name" key={form.key("title")} {...form.getInputProps("title")} />
    </>
  );
}
